import React, { useCallback } from "react";
import NavItem from "views/components/sidebar/NavItem";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectUndoRedoAvailability } from "views/logic/slices/undoRedoSelectors";
import { redo } from "views/logic/slices/undoRedoActions";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useHotkey from "hooks/useHotkey";
import useViewType from "views/hooks/useViewType";
const TITLE = "Redo";
const RedoNavItem = ({ sidebarIsPinned }) => {
  const viewType = useViewType();
  const dispatch = useViewsDispatch();
  const { isRedoAvailable } = useViewsSelector(selectUndoRedoAvailability);
  const sendTelemetry = useSendTelemetry();
  const onClick = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_SIDEBAR_REDO, {
      app_action_value: "search-sidebar-redo"
    });
    return dispatch(redo());
  }, [dispatch, sendTelemetry]);
  useHotkey({
    actionKey: "redo",
    callback: () => dispatch(redo()),
    scope: viewType.toLowerCase()
  });
  return /* @__PURE__ */ React.createElement(
    NavItem,
    {
      disabled: !isRedoAvailable,
      onClick,
      icon: "redo",
      title: TITLE,
      ariaLabel: TITLE,
      sidebarIsPinned
    }
  );
};
export default RedoNavItem;
